import packsData from "@/data/packs.json";

const packCatalog = Array.isArray(packsData) ? packsData : [];

export function packBySlug(slug) {
  return packCatalog.find((pack) => pack.slug === slug) || null;
}

export function flattenQuestRewards(rewards) {
  const entries = [];
  if (!rewards) return entries;

  if (Array.isArray(rewards)) {
    for (const item of rewards) {
      if (!item || typeof item !== "object") continue;
      if (item.type === "pack") {
        entries.push({
          kind: "pack",
          pack_slug: item.pack_slug,
          amount: item.amount || 1,
        });
      } else if (item.type) {
        entries.push({
          kind: "resource",
          type: item.type,
          amount: item.amount,
        });
      }
    }
    return entries;
  }

  if (typeof rewards !== "object") return entries;

  for (const [key, value] of Object.entries(rewards)) {
    if (key === "packs" && Array.isArray(value)) {
      for (const pack of value) {
        if (!pack || !pack.pack_slug) continue;
        entries.push({
          kind: "pack",
          pack_slug: pack.pack_slug,
          amount: pack.amount || 1,
        });
      }
    } else if (Array.isArray(value)) {
      for (const item of value) {
        entries.push({ kind: "item", type: key, amount: item });
      }
    } else if (value !== undefined && value !== null && typeof value !== "object") {
      entries.push({ kind: "resource", type: key, amount: value });
    }
  }
  return entries;
}
